/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { UserRegisterCreateData, UserRegisterCreateStatus200, UserRegisterCreateStatus400 } from "../types/UserRegisterCreate.ts";

function getUserRegisterCreateUrl() {
	const res = { method: "POST", url: `/api/user/register` as const };

	return res;
}

/**
 * @description Регистрация пользователя по ОТП-коду.
 * @summary регистрация по ОТП
 * {@link /api/user/register}
 */
export async function userRegisterCreate(
	data: UserRegisterCreateData,
	config: Partial<RequestConfig<UserRegisterCreateData>> & { client?: Client; contentType?: "application/json" | "application/xml" } = {},
) {
	const { client: request = client, contentType = "application/json", ...requestConfig } = config;

	const requestData = data;

	const res = await request<UserRegisterCreateStatus200, ResponseErrorConfig<UserRegisterCreateStatus400>, UserRegisterCreateData>({
		method: "POST",
		url: getUserRegisterCreateUrl().url.toString(),
		data: requestData,
		contentType,
		...requestConfig,
	});

	return res.data;
}
